import React from "react";
import {inject, observer} from "mobx-react";
import UpdateCustomer from "./UpdateCustomer";
import {Alert, Container} from "reactstrap";

const InfosOnCustomers = inject("rootStore") (observer( class InfosOnCustomers extends React.Component {

    user

    get injected() {
        return this.props;
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
            user: this.injected.user,
            invoices: [],
            activeTab: this.injected.location.aboutProps?.activeTab ?? 0,
            devis: [],
            appareils:  [],
            tickets: [],
            priseencharges: [],
            introuvable: false
        }

        this.injected.rootStore.savedDatasStore.setHeader("Clients", "Gestion des clients et des documents liés", "clients.jpg", this.injected.rootStore.userStore)
    }


    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.onRouteChanged();
        }
    }

    async onRouteChanged() {
        let userId = this.props.match && parseInt(this.props.match.params.id, 10);

        if (userId) {
            const user = await this.injected.rootStore.userStore.findUserById(userId);

            if (!user) {
                // Fiche inexistante, ou compte admin/employé (l'API ne renvoie que les clients) :
                // on n'affiche pas la fiche du client consulté juste avant.
                this.setState({introuvable: true, user: undefined})
                return
            }

            this.setState({
                introuvable: false,
                user: user,
                invoices: user?.facture ?? [],
                devis: user?.devis ?? [],
                appareils: user?.appareils ?? [],
                tickets: user?.ticket ?? [],
                priseencharges: user?.prise_en_charge ?? []
            })
        }
    }

     componentDidMount() {
         this.onRouteChanged()
    }

    render() {
        if (this.state.introuvable) {
            return (
                <Container className="mt-4" fluid>
                    <Alert color="warning">
                        Cette fiche n'est pas une fiche client : elle n'existe pas, ou c'est un compte administrateur ou employé.
                    </Alert>
                </Container>
            );
        }

        return (
            <>
                <UpdateCustomer activeTab={this.state.activeTab} appareils={this.state.appareils} user={this.state.user} devis={this.state.devis} tickets={this.state.tickets} invoices={this.state.invoices} priseencharges={this.state.priseencharges}/>
            </>
        );
    }
}));

export default InfosOnCustomers;
